const mapObject = (source: Record<string, unknown>, target: Record<string, unknown>) => {
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            const element = source[key];

            if (Object.prototype.hasOwnProperty.call(target, key)) {
                target[key] = element;
            }
        }
    }
};

export default mapObject;
